import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { FEED_OPTIONS, getEnabledFeedOptions, isFeedOptionAvailable } from "~/dynamic-components/constants/feed-options";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class SmartFeedSelection extends BaseOption {
  static userInterfaceComponent = () => {
    const availableFeedOptions = getEnabledFeedOptions();

    const options = Object.keys(availableFeedOptions)
        .filter(feed => !availableFeedOptions[feed].deprecated)
        .map(feed => ({
          id: feed,
          name: availableFeedOptions[feed].displayName || camelToTitleCase(feed, true),
        }));

    return {
      label: "Please select a feed",
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options,
      },
    };
  };

  static defaultValue = "";

  static convertConfigValueToCompiledValue(configValue) {
    // If you are replacing an existing feed-option
    if (!configValue) {
      return "";
    }

    if (!FEED_OPTIONS[configValue]) {
      return "";
    }

    if (FEED_OPTIONS[configValue].deprecated) {
      switch (configValue) {
        case "ExclusiveStories":
          return "HomeStories";
      }
    }

    if (!isFeedOptionAvailable(configValue)) {
      return "";
    }

    return configValue;
  }
}
